import { render, staticRenderFns } from "./BlogRead.vue?vue&type=template&id=b28d1f52&scoped=true"
import script from "./BlogRead.vue?vue&type=script&lang=ts"
export * from "./BlogRead.vue?vue&type=script&lang=ts"
import style0 from "./BlogRead.vue?vue&type=style&index=0&id=b28d1f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28d1f52",
  null
  
)

export default component.exports